// SKYFELL — script minimal du thème
(function () {
  'use strict';

  // Synchronise le select de variante caché avec les options visibles
  var form = document.querySelector('.product-form');
  if (!form) return;

  var hidden = form.querySelector('select[name="id"]');
  var optionSelects = form.querySelectorAll('select[name^="options"]');
  if (!hidden || optionSelects.length === 0) return;

  function updateVariant() {
    var chosen = [];
    optionSelects.forEach(function (sel) { chosen.push(sel.value); });
    var target = chosen.join(' / ');

    Array.prototype.forEach.call(hidden.options, function (opt) {
      if (opt.textContent.trim() === target) {
        hidden.value = opt.value;
      }
    });
  }

  optionSelects.forEach(function (sel) {
    sel.addEventListener('change', updateVariant);
  });
})();
